import { render, staticRenderFns } from "./ListRole.vue?vue&type=template&id=1ebf1104&scoped=true"
import script from "./ListRole.vue?vue&type=script&lang=js"
export * from "./ListRole.vue?vue&type=script&lang=js"
import style0 from "./ListRole.vue?vue&type=style&index=0&id=1ebf1104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf1104",
  null
  
)

export default component.exports